export default __webpack_public_path__ + "static/media/Main-Layout-Header-Image-Landscape-Tablet.608645c4.png";